import { grayscale } from './grayscale';
import { sobel } from './sobel';
import { invert } from './invert';
import { hue } from './hue';
import { lightness } from './lightness';
import { saturation } from './saturation';
import { alpha } from './alpha';
import { sepia } from './sepia';
import { posterize } from './posterize';
import { gamma } from './gamma';


export default {
  grayscale,
  sobel,
  invert,
  hue,
  saturation,
  lightness,
  alpha,
  sepia,
  posterize,
  gamma,
}